import { API } from 'shared/utils/apiMiddleware';
import { BILLINGS_API_NAME, USER_MANAGEMENT_TOKENS } from './helperFunctions';

export async function fetchCustomerOrganizationToken(customerId) {
  const encodedCustomerId = encodeURIComponent(customerId);
  return API.get(BILLINGS_API_NAME, `${USER_MANAGEMENT_TOKENS}/customer-tokens/${encodedCustomerId}`);
}
